import * as React from 'react';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    root:{
        width:theme.spacing(8),
        height:2,
        backgroundColor:theme.palette.primary.main
    }
}));
export default function DividerText() {
    const classes = useStyles();
    return (
        <div className={classes.root}/>
    );
  }